module.exports = __webpack_public_path__ + "static/media/sort.ffec0d8f.svg";